import { useState, useEffect } from 'react';
import { useWeb3React } from '@web3-react/core';
import LendBorrowHOC from 'hoc/LendBorrowHOC';
import SyncCard from 'components/UI/SyncCard';
import OffersTable from 'parts/Assets/OffersTable';
import { getBorrowerOffersByAddress } from 'services/nftfi';

function OffersPage({}) {
  const { account } = useWeb3React();
  const [offers, setOffers] = useState();

  const fetchOffers = async () => {
    try {
      const result = await getBorrowerOffersByAddress(account);
      setOffers(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (account) {
      fetchOffers();
    }
  }, [account]);

  return (
    <SyncCard>
      {offers && <OffersTable offers={offers} setOffers={setOffers} address={account} />}
    </SyncCard>
  );
}

export default LendBorrowHOC(OffersPage, false);
